// extracted by mini-css-extract-plugin
export default {"footer":"V_4","row":"V_fz","menu-column":"V_fB"};